// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2wnmm","actionsCol":"EnrolledClinics_actionsCol__3a6-9"};